export default [
    {
        title: '话题管理',
        path: '/topic',
        name: 'topicManagement',
        meta: {
            key: 'topic',
            open: 'topic'
        },
        permission: 'topicManagement',
        menu: true,
        component: () => import('@/views/topic/list')
    }
];
